import 'twin.macro';

import { TimerReset } from 'lucide-react';

import { ActionBoxDataType, LINK_TYPE } from '@/containers/IntervieweeCardContainer/types';

import ClipboardCopyInput from '../ClipboardCopyInput';
import ExpiryLinkCopyInput from '../ExpiryLinkCopyInput';
import { Button } from '../base';

const ProfileActionBox = ({
  label,
  description,
  urls,
  handleRefreshUrl,
  isLoading,
}: ActionBoxDataType) => {
  if (!Array.isArray(urls) || urls.length === 0) return null;

  const inputComponents = urls.map((linkItem, idx) => {
    const { linkType, value } = linkItem;

    switch (linkType) {
      case LINK_TYPE.EXPIRY_LINK_COPY:
        return (
          <ExpiryLinkCopyInput
            key={idx}
            shouldDisplayUrl={false}
            url={value as string}
            onRefreshUrl={handleRefreshUrl}
            loading={isLoading}
          />
        );
      case LINK_TYPE.URL_COPY:
        return <ClipboardCopyInput key={idx} shouldDisplayUrl={false} url={value as string} />;
      case LINK_TYPE.ACTIVATE_MODAL:
        return (
          <Button
            variant="info"
            onClick={value as () => void}
            tw="flex flex-row gap-2 items-center justify-center text-sm"
            key={idx}
          >
            <TimerReset tw="h-5 w-5" />
            <span>ล้างการสัมภาษณ์</span>
          </Button>
        );
      default:
        return null;
    }
  });

  return (
    <div tw="border-r-0 w-full py-4 px-2 bg-white flex flex-col items-start justify-between sm:(p-4 border-r-0) lg:(border-r [&:nth-child(2n)]:border-r-0 last:border-r-0) xl:(last:border-r-0! [&:nth-child(2n)]:border-r)">
      <div tw="mb-3">
        <p tw="text-sm text-gray-900 font-medium whitespace-pre-line">{label}</p>
        {description && <p tw="text-sm text-gray-700">{description}</p>}
      </div>
      <div tw="flex flex-col gap-2 sm:(flex-row items-center)">{inputComponents}</div>
    </div>
  );
};

export default ProfileActionBox;
